import * as z from "zod";

export const DateFromDateOrIsoStringSchema = z
  .union([z.iso.datetime({ offset: true }), z.date()])
  .pipe(z.coerce.date())
  .meta({ annotation: "Date" });
